import _ from 'underscore'

import { getEventReminders } from '../sagas/network'
import {
    GetEventRemindersResponse,
    GetEventRemindersTransformedResponse,
} from 'api/actions/home/eventReminders/eventRemindersActions'
import { Queries } from 'api/queries.enum'

import { useQuery } from './useQuery'

const convertTo24Hour = (time12h: string): string => {
    const [time, period] = time12h.split(' ')

    const [hours, minutes] = time.split(':')
    let hoursNumeric: number = parseInt(hours, 10)

    if (period === 'PM' && hoursNumeric !== 12) {
        hoursNumeric += 12
    } else if (period === 'AM' && hoursNumeric === 12) {
        hoursNumeric = 0
    }

    const hoursFormatted: string = hoursNumeric.toString().padStart(2, '0')

    return `${hoursFormatted}:${minutes}+00:00`
}

export const useEventReminders = () => {
    const transformData = (data: GetEventRemindersResponse): GetEventRemindersTransformedResponse => {
        if (_.isEmpty(data)) {
            return []
        }

        return data.map((event) => {
            let dateString = ''
            const time = event.eventDateInfo.time ? convertTo24Hour(event.eventDateInfo.time) : event.eventDateInfo.time

            if (event.eventDateInfo.year) {
                dateString += event.eventDateInfo.year
            }

            if (event.eventDateInfo.month) {
                if (dateString.length) {
                    dateString += '-'
                }

                const monthNumber = new Date(`${event.eventDateInfo.month} 01 2000`).toLocaleDateString(`en`, {
                    month: `2-digit`,
                })

                dateString += monthNumber
            }
            if (event.eventDateInfo.day) {
                if (dateString.length) {
                    dateString += '-'
                }

                dateString += event.eventDateInfo.day
            }

            return {
                date: dateString,
                time,
                title: event.title,
                description: event.description,
                link: event.link,
                linkProps: {
                    target: '_blank',
                },
            }
        })
    }

    return useQuery<GetEventRemindersResponse, Error, GetEventRemindersTransformedResponse>({
        queryKey: [Queries.getEventReminders],
        queryFn: getEventReminders,
        select: transformData,
    })
}
